import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Grid,
  TextField,
} from '@material-ui/core';

import Dialog from '../Dialog';
import { Button, Typography } from '../Wrappers/Wrappers';
import ButtonProgress from '../../commons/ButtonProgress';
import { useStyles } from './styles.js';
import { useEnterPhoneNumber } from './useEnterPhoneNumber';

const DIALOG_TITLE = 'Enter your new phone number';
const PHONE_HELPER_TEXT = 'Please follow phone number format: +[country code] [phone number] (e.g., +61400123456)';

function EnterPhoneNumber ({ open, onCancel, onVerify }) {
  const classes = useStyles();

  const {
    phone,
    isValid,
    isLoading,
    fieldState,
    handleChange,
    handleBlur,
    handleCancel,
    handleVerify,
  } = useEnterPhoneNumber(open, onCancel, onVerify);

  const textFieldClass = {
    default: classes.textFieldDefault,
    error: classes.textFieldError,
    success: classes.textFieldSuccess,
  }[fieldState];

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      PaperProps={{
        classes: {
          root: classes.dialogContainer,
        },
      }}
    >
      <Grid className={classes.content}>
        <Grid item container className={classNames([classes.titleSpace])}>
          <Typography weight={'medium'} variant={'h5'} className={classes.titleText}>
            {DIALOG_TITLE}
          </Typography>
        </Grid>

        <Grid item container className={classNames([classes.inputSpace])}>
          <TextField
            variant="outlined"
            fullWidth
            label="Phone number (e.g., +61400123456)"
            value={phone}
            onChange={handleChange}
            onBlur={handleBlur}
            error={fieldState === 'error'}
            helperText={fieldState === 'error' ? PHONE_HELPER_TEXT : undefined}
            className={textFieldClass}
            inputProps={{ 'aria-label': 'Phone number' }}
          />
        </Grid>

        <Grid item container className={classNames([classes.buttonSpace])}>
          <Button
            onClick={handleCancel}
            className={classes.cancelButton}
            disabled={isLoading}
          >
            Cancel
          </Button>

          <ButtonProgress
            label="Verify"
            variant="contained"
            onClick={handleVerify}
            disabled={!isValid}
            showProgress={isLoading}
            width="90px"
          />
        </Grid>
      </Grid>
    </Dialog>
  );
}

EnterPhoneNumber.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  onVerify: PropTypes.func,
};

EnterPhoneNumber.defaultProps = {
  open: false,
  onCancel: () => {},
  onVerify: () => {},
};

export default observer(EnterPhoneNumber);
